const angular = require('angular');

class PriceController {
    constructor(currencyFilter) {
        this.currencyFilter = currencyFilter;
    }

    $onInit() {
        if (angular.isUndefined(this.priceCentsVisible)) {
            this.priceCentsVisible = true;
        }

        this.buildDisplayPrice(this.price);
    }

    $onChanges(change) {
        this.buildDisplayPrice(change.price.currentValue);
    }

    buildDisplayPrice(price) {
        if (price === undefined) { return; }

        const displayPrice = this.currencyFilter(price);

        this.currencySymbol = displayPrice.slice(0, 1);
        [this.priceDollar, this.priceCents] = displayPrice.slice(1).split('.');
    }
}

const priceControllerComponentDefinition = {
    bindings: {
        per: '<?',
        price: '<',
        priceClassModifier: '@?',
        priceCentsVisible: '<?',
    },
    controller: ['currencyFilter', PriceController],
    template: require('./price.component.html').trim(),
};

module.exports = {
    PriceController,
    priceControllerComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/price/price.component.js